import { useEffect, useState } from 'react'

type ColorScheme = 'light' | 'dark'
type ColorSchemeListener = (colorScheme: ColorScheme) => void

const getCurrentColorScheme = (): ColorScheme => {
    return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}

declare global {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface Window {
        colorSchemeListeners: ColorSchemeListener[]
    }
}

export const useColorScheme = (): ColorScheme => {
    const [colorScheme, setColorScheme] = useState<ColorScheme>(getCurrentColorScheme)

    useEffect(() => {
        window.colorSchemeListeners ||= []

        const changeListener: ColorSchemeListener = (colorScheme) => {
            setColorScheme(colorScheme)
        }

        const observer = new MutationObserver(() => {
            setColorScheme(getCurrentColorScheme())
        })

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class'],
        })

        window.colorSchemeListeners.push(changeListener)

        return () => {
            observer.disconnect()
            window.colorSchemeListeners = window.colorSchemeListeners.filter((l) => l !== changeListener)
        }
    }, [])

    return colorScheme
}
